module.exports = __webpack_public_path__ + "img/1.487b3843.jpg";